import * as React from "react";
const SvgEventMgmtIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 149 149"
    {...props}
  >
    <circle cx={74.5} cy={74.5} r={72.5} stroke="#FFA100" strokeWidth={4} />
    <path
      stroke="#FFA100"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={5}
      d="M73 55.394v17.93m-34.16 9.86c-4.077 7.06-6.115 10.591-5.81 13.488a8.965 8.965 0 0 0 3.647 6.316c2.356 1.712 6.43 1.712 14.577 1.712h43.492c8.147 0 12.221 0 14.576-1.712a8.966 8.966 0 0 0 3.648-6.316c.305-2.897-1.732-6.428-5.809-13.488L85.423 45.532c-4.076-7.061-6.116-10.59-8.777-11.775a8.968 8.968 0 0 0-7.294 0c-2.66 1.184-4.698 4.714-8.77 11.768L38.838 83.184Zm34.388 3.586v.449h-.451v-.449h.45Z"
    />
  </svg>
);
export default SvgEventMgmtIcon;
